import React, { useState } from "react";
import { deleteProfile } from "../services/user.service";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { SWAL_SETTINGS, ROLE } from "../../../utils/Constants";
import { getUser, clearUserSession } from "../../../utils/commonfunction";

function DeleteAccount({ onClose }) {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userData = getUser(ROLE.USER) || {};

  const deleteUserAccount = async () => {
    if (!userData?._id) return;

    setLoading(true);
    try {
      const resp = await deleteProfile({ _id: userData._id });
      if (resp?.Code === 0 || resp?.success === true) {
        clearUserSession();
        navigate('/');
        if (onClose) onClose();
        Swal.fire({
          icon: "success",
          text: resp?.Message || resp?.message || "Account deleted successfully",
          ...SWAL_SETTINGS,
        });
      } else {
        Swal.fire({
          icon: "error",
          text: resp?.Message || resp?.message || "Failed to delete account",
          ...SWAL_SETTINGS,
        });
      }
    } catch (error) {
      console.error("Delete account error:", error);
      Swal.fire({
        icon: "error",
        text: error?.response?.data?.Message || "An error occurred while deleting the account.",
        ...SWAL_SETTINGS,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div className="text-center flex items-center justify-center flex-col gap-[15px]">
        <img src="/images/delete-account.png" />
        <div className="flex flex-col gap-[10px]">
          <h1 className="headings-h1 text-zinc-800">{t("delete_account")}</h1>
          <p className="body-lg text-gray-500">{t("are_you_sure_to_delete")}</p>
        </div>
        <div className="flex items-center gap-[15px] w-full mt-[15px]">
          <button
            className="btn btn-outline flex-1"
            onClick={deleteUserAccount}
            disabled={loading}
          >
            {loading ? "Deleting..." : t("btn_yes")}
          </button>
          <button
            className="btn btn-pri flex-1"
            onClick={() => { if (onClose) onClose(); }}
            disabled={loading}
          >
            {t("btn_no")}
          </button>
        </div>
      </div>
    </>
  );
}

export default DeleteAccount;
